export type TimeWindow =
'morning' |
'afternoon' |
'evening' |
'full_day' |
'custom';

export interface TripStop {
  id: string;
  placeId: string;
  startTime: string; // 'HH:MM' 24h
  endTime: string; // 'HH:MM'
  visitDurationMinutes: number;
  travelMode: 'walk' | 'drive';
  travelMinutesFromPrevious: number;
  travelDistanceKm: number;
  notes?: string;
  userOverride?: {startTime?: boolean;endTime?: boolean;duration?: boolean;};
}

export interface TripDay {
  id: string;
  dayNumber: number;
  label?: string;
  dateISO?: string;
  timeWindow: TimeWindow;
  customStartTime?: string; // 'HH:MM'
  customEndTime?: string;
  stops: TripStop[];
}

export interface TripPlan {
  id: string;
  name: string;
  description?: string;
  coverImage?: string;
  createdAt: string;
  updatedAt: string;
  days: TripDay[];
  /** When true, the editor requests the user's location and sorts the
   * place-search panel by distance from the user, nearest first. */
  sortByLocation?: boolean;
}

const STORAGE_KEY = 'ahg.trip_plans.v1';

export function loadAllUserPlans(): Record<string, TripPlan[]> {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    return JSON.parse(raw);
  } catch {
    return {};
  }
}

export function loadUserPlans(userId: string): TripPlan[] {
  const all = loadAllUserPlans();
  return all[userId] || [];
}

export function saveUserPlans(userId: string, plans: TripPlan[]) {
  if (typeof window === 'undefined') return;
  try {
    const all = loadAllUserPlans();
    all[userId] = plans;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
    window.dispatchEvent(new Event('ahg.trip_plans.changed'));
  } catch {

    // ignore
  }}